import axios from "axios";

import endPoints from "../../../../config/endPoints";

//get all data related to the dashboards
// export const getDashboardData = async () => {
//     return await axios.get(`${endPoints.dashboard}/`);
// };

export const getDailyStatistics = async (reqBody) => {
    return await axios.post(`${endPoints.dashboard}/daily-trans`, reqBody);
};

export const getMonthlyTransactions = async (reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-trans`, reqBody);
};

export const getMonthlyRevenue = async (reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-revs`, reqBody);
};

export const getMonthlyReceipts = async (reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-trans-by-status`, reqBody);
};

// /dashboards/monthly-trans-by-status
// /dashboards/daily-trans
// /dashboards/monthly-trans
// /dashboards/monthly-revs